import { type AxiosInstance } from "axios";
import type { Order } from "@/features/dmManagement/types";
import { handleMutationError } from "@/features/dmManagement/api/handleApiError";

/**
 * 指定された発注の宛先リストを確定する。
 * @param apiClient - axios インスタンス
 * @param id - 発注ID
 * @returns 更新後の発注情報
 */
export const PostAddressListConfirmAPI = async (
  apiClient: AxiosInstance,
  id: number
): Promise<Order> => {
  const url = `/dm/orders/${id}/address-list/confirm/`;

  try {
    const response = await apiClient.post<Order>(url);
    return response.data;
  } catch (error) {
    return handleMutationError(error);
  }
};
